import {
  isVoucherApiErrorCode,
  VOUCHER_API_ERROR_MESSAGES_VI,
  type VoucherApiErrorCode,
} from "@/constants/voucher/voucherErrorCodes"
import type { TFunction } from "i18next"

const toErrorCode = (value: unknown): number | undefined => {
  const n = Number(value)
  return Number.isFinite(n) && n !== 0 ? n : undefined
}

const toMessage = (value: unknown): string | undefined => {
  if (value == null || value === "") return undefined
  return String(value).trim() || undefined
}

/** Đọc `errorCode` / `message` từ body API (200 + errorCode hoặc reject từ axios). */
export const extractVoucherApiError = (
  payload: unknown,
): { errorCode?: VoucherApiErrorCode; message?: string } => {
  if (!payload || typeof payload !== "object") return {}

  const root = payload as Record<string, unknown>
  const rootCode = toErrorCode(root.errorCode ?? root.error_code)
  if (isVoucherApiErrorCode(rootCode)) {
    return {
      errorCode: rootCode,
      message: toMessage(root.message ?? root.reason ?? root.errorMessage ?? root.error),
    }
  }

  const nested =
    root.data && typeof root.data === "object"
      ? (root.data as Record<string, unknown>)
      : null
  if (nested) {
    const nestedCode = toErrorCode(nested.errorCode ?? nested.error_code)
    if (isVoucherApiErrorCode(nestedCode)) {
      return {
        errorCode: nestedCode,
        message: toMessage(
          nested.message ?? nested.reason ?? nested.errorMessage ?? nested.error,
        ),
      }
    }
  }

  return { message: toMessage(root.message ?? root.reason ?? root.errorMessage) }
}

export const getVoucherValidateErrorMessage = (
  payloadOrCode: unknown,
  t?: TFunction,
): string => {
  const extracted =
    typeof payloadOrCode === "number"
      ? { errorCode: isVoucherApiErrorCode(payloadOrCode) ? payloadOrCode : undefined }
      : extractVoucherApiError(payloadOrCode)

  const { errorCode, message } = extracted

  if (errorCode) {
    const i18nKey = `voucher.errors.${errorCode}`
    if (t) {
      return t(i18nKey, {
        defaultValue: VOUCHER_API_ERROR_MESSAGES_VI[errorCode],
      })
    }
    return VOUCHER_API_ERROR_MESSAGES_VI[errorCode]
  }

  if (message) return message

  if (t) {
    return t("voucher.invalid_message", {
      defaultValue: "Mã khuyến mãi không hợp lệ.",
    })
  }
  return "Mã khuyến mãi không hợp lệ."
}
